import { axios } from 'src/lib/axios';
import { API_URL } from 'src/config';

export const updateUserAccount = (data) => {
  return axios.post(`${API_URL}/account/user_change_password`, data);
};
